import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { Fixed2 } from "../../../../common/utils/common.utils";
import { findInvoiceRoute } from "../../../../layout/components/SearchInvoices";
import { IVendorPaymentReportList } from "../types/VendorPaymentTypes";

export const VendorPaymentReportUtils =
  (): ColumnsType<IVendorPaymentReportList> => {
    return [
      {
        title: "SL.",
        dataIndex: "key",
        key: "key",
        render: (_, data, index) => <>{1 + index}</>,
      },
      {
        title: "Payment Date",
        key: "payment_date",
        render: (_, record) => {
          return `${dayjs(record.payment_date).format("DD MMM YYYY")}`;
        },
      },
      {
        title: "Voucher No",
        key: "vouchar_no",
        dataIndex: "vouchar_no",

        // render: (_, data) => {
        //   const { vpay_vendor_id, vouchar_no } = data;

        //   return (
        //     <>
        //       <Link to={`../vendors/payment/${vpay_vendor_id}`}>
        //         {vouchar_no}
        //       </Link>
        //     </>
        //   );
        // },
      },

      {
        title: "Vendor Name",
        key: "vendor_name",
        dataIndex: "vendor_name",
      },
      {
        title: "Payment Type",
        key: "vpay_payment_to",
        dataIndex: "vpay_payment_to",
      },
      {
        title: "Online Charge",
        key: "online_charge",
        dataIndex: "online_charge",
        align: "right",
        render: (online_charge) => {
          return <> {Number(Fixed2(online_charge))} </>;
        },
      },
      {
        title: "Amount",
        key: "payment_amount",
        dataIndex: "payment_amount",
        align: "right",
        render: (payment_amount) => {
          return <> {Number(Fixed2(payment_amount))} </>;
        },
      },
      {
        title: "Note",
        key: "note",
        dataIndex: "note",
      },
    ];
  };
